import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getReaction, DEFAULT_REACTION } from '../../utils/reactions';

/**
 * Compact reaction glyph. Parent controls size/color overrides.
 */
export default function ReactionIcon({
  type = DEFAULT_REACTION,
  size = 16,
  color,
  style = {},
  title,
}) {
  const reaction = getReaction(type);
  return (
    <span
      title={title || reaction.label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: color || reaction.color,
        fontSize: size,
        lineHeight: 1,
        userSelect: 'none',
        ...style,
      }}
    >
      <FontAwesomeIcon icon={reaction.icon} />
    </span>
  );
}
